module.exports = __webpack_public_path__ + "images/花筑奢pr长图_06-1.jpg?v=0773e5dd";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_06-1.jpg
 ** module id = 37
 ** module chunks = 1 2
 **/